import { userLogout } from '../dataSource/auth_requests';
import { routesPaths } from '../routes/RoutesPaths';
import { removeUserFromStorage } from './users';

export const handleLogout = (history, sendTo = routesPaths.root, tokenIsActive = false) => {
  tokenIsActive && userLogout();
  removeUserFromStorage();
  history.push(sendTo);
};
